import { FunctionComponent, ReactNode } from 'react'
//import { ProductData } from '@/types/product'
//import DeleteAbsoluteButton from '@/components/UiElements/DeleteAbsoluteButton'
import React from 'react'
import Popover from '@/components/UiElements/PopOver'
import Alert from '@/components/UiElements/Alert'




type PriceListItemProps = {
	model: any
	className?: string
	onDelete?: (id: string) => void
	callBack: (item:any) => void
}

const Label = ({title, value, enable = true, className}: { title: string | ReactNode; value: string | ReactNode; enable?: boolean; className?: string | null }) => {
	return (
		<div className={`py-sm px-md h-[50px] rounded-md transition-all ${enable ? "bg-gray-100 group-hover:bg-gray-200 " : "bg-gray-50 group-hover:bg-gray-100"} ${enable ? "text-gray-900 group-hover:text-gray-900" : "text-gray-400 group-hover:text-gray-900"} ${className || ""}`}>
			<p className={"text-gray-400 text-xs"}>{title}</p>
			<p className={` text-sm  capitalize `}>{value}</p>
		</div>
	)
}


const PriceListItem: FunctionComponent<PriceListItemProps> = ({ model, className = '', onDelete, callBack }) => {





	const mapModel: Record<string, string> = {
		FIXED: 'Fixed Price for Product',
		SECTION: 'Price Per Section',
		ELEMENT: 'Price Per Element',
		SIZE: 'Price Per Size',
	};

	const key = (model?.price_model?.value || '').toUpperCase() as keyof typeof mapModel;


	const handleDeleteItem = () => {
		Alert.showAlert({
			title: 'Delete model',
			isCancelable: true,
			danger: true,
			button: 'Delete!',
			message:
				<div className={'flex flex-col items-center justify-center '}>

					Are you sure you want to delete the model &quot;{model?.name}&quot;?
				</div>,
			callBack: async (ok) => {
				if (ok && model) {
					onDelete?.(model.id)
				}

			},
		})
		//if (onDelete) onDelete(model)
	}






	return (
		<div
			onClick={() => {
				callBack(model)
			}}
			id={model.id}
			className={`relative group active:bg-gray-100 flex py-sm  border-b-gray-200 border-b-[1px] items-center hover:bg-gray-50 cursor-pointer transition-all group gap-xl px-md h-[120px] ${className} ` }
		>


			<Popover
				toggle={(open) => (
					<div
						className={` select-none w-[37px] h-[37px] min-w-[37px] ${open ? "text-white bg-gray-900" : " bg-gray-200 hover:bg-gray-700 text-gray-900 hover:text-white"}     rounded-full flex-col justify-center items-center inline-flex font-icon-regular cursor-pointer transition-all`}


					>
						<div className="text-center ">ellipsis</div>
					</div>
				)}
				placement="bottom left"
				offsetX={0}
				offsetY={10}
				menu={[

					{
						title: <span className="capitalize">Edit Model</span>,
						icon: '',
						onClick: ()=> callBack(model)

					},
					{
						title: <span className="capitalize">Duplicate </span>,
						icon: '',
						onClick: ()=> callBack({...model, id: "duplicate"})

					},
					{ separator: true, className: 'my-[10px]' },
					{
						title: <span className="capitalize">Delete</span>,
						icon: '',
						className: 'hover:bg-red-100 text-red-500',
						onClick:handleDeleteItem
					}
					,]}
			/>

			<div className={' flex flex-col justify-between f-full gap-md items-start transition-all h-[90px] w-full mix-blend-multiply'}>


				<div
					className={`text-title-md pl-md transition-all capitalize `}>
					{model.name}
				</div>


				<div className={'flex flex-row gap-sm justify-between w-full '}>

					<div className={'flex flex-row gap-sm'}>

						<Label
							title="Model"
							value={mapModel[key] ?? ''}
							className={`w-[200px] capitalize`}
						/>

						<Label
							title="Price"
							value={model.price}
							className={`w-[100px] capitalize`}
						/>

					</div>


				</div>


			</div>


		</div>
	)
}


export default PriceListItem